/* =================== CRIA PAGAMENTO =================== */
jQuery(document).ready(function () {

  // Grava o pagamento
  $(".bt-registrar-pagamento").on("click", function (e) {
    e.preventDefault();
    if (
      $("#form-pagamento")
        .parsley()
        .validate()
    ) {
      var dados = $("#form-pagamento").serialize();
      $.ajax({
        type: "POST",
        url: url_base + "acoes/app/pagamentos/grava_pagamento.php?acao=insert",
        data: dados,
        beforeSend: function () {
          showLoading();
        },
        success: function (data) {
          console.log(data);
          data = $.parseJSON(data);
          hideLoading();
          if (data.status_pagamento != 14) {
            if($('#id_pedido').val() == 'direito'){
              location.href = url_base + "minha-conta/confirmacao/" + data.hash + "/"+ $('#id_usuario').val();
            }else{
              location.href = url_base + "minha-conta/confirmacao/" + data.hash;
            }
          } else {
            showAlert('Erro', 'Não foi possível realizar essa operação, revise os dados.', 'error');
          }
        },
        error: function (xhr, type, exception, data) {
          hideLoading();
          console.log(data);
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
        }
      });
    }
  });
});
